import { Outlet, useParams } from "react-router-dom";

import { useTournament } from "@/routes/tournament/queries";

export default function TournamentLayout() {
    const { tournamentId } = useParams<{ tournamentId: string }>();

    const { tournament, loading, error, refetch } = useTournament(tournamentId);

    if (!tournamentId) {
        return null;
    }

    if (loading) {
        return <p>Loading...</p>;
    }

    if (error) {
        return <p>Error: {error.message}</p>;
    }

    if (!tournament) {
        return <p>Tournament not found</p>;
    }

    return <Outlet context={{ tournament, refetch }} />;
}
